import { toast } from "react-toastify";
import * as moment from "moment";

// custom pages
import config from "config/config";
import HandleApiResponse from "utils/handleApiResponse";

const reportsAPI = () => {
  const { handleResponse, handleError } = HandleApiResponse();

  async function getAllManagerProjects() {
    try {
      const obj = {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
      };
      let res = await fetch(
        `${config.host}/panel/reports/timesheet-summary/projects`,
        obj
      );
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function getAllManagerEmployees() {
    try {
      const obj = {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
      };
      let res = await fetch(
        `${config.host}/panel/reports/timesheet-summary/employees`,
        obj
      );
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function getTimesheetSummaryReportAPI(body) {
    try {
      const obj = {
        method: "Post",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      };
      let res = await fetch(
        `${config.host}/panel/reports/timesheet-summary`,
        obj
      );
      if (res.ok) {
        const blob = await res.blob();
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `TimesheetSummary ${moment().format("YYYY-MM-DD h_mm_ss A")}.xlsx`
        );
        document.body.appendChild(link);
        link.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(link);
        toast.success("File Downloaded Successfully", {
          toastId: "file-success",
        });
        return;
      }
      toast.error("File Not Found", { toastId: "file-error" });
      return;
    } catch (err) {
      handleError(err);
    }
  }

  async function getTimesheetSummaryReportViewAPI(body) {
    try {
      const obj = {
        method: "Post",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      };
      let res = await fetch(
        `${config.host}/panel/reports/timesheet-summary-view`,
        obj
      );
     
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }


  async function getAllProjectNames(value) {
    try {
      const obj = {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
      };
      let res = await fetch(
        `${config.host}/panel/reports/weekly-report-projects?projectStatus=${value}`,
        obj
      );
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function getAllProjectTasks(values) {
    try {
      const obj = {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
      };
      const query = JSON.stringify(values);
      let res = await fetch(
        `${config.host}/panel/reports/weekly-report-tasks?query=${query}`,
        obj
      );
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function getWeeklyReportAPI(body) {
    try {
      const obj = {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      };
      let res = await fetch(`${config.host}/panel/reports/weekly-report`, obj);

      if (res.ok) {
        const contentType = res.headers.get("Content-Type");
        if (contentType && contentType.includes("application/json")) {
          const json = await res.json();
          if (json.message === "No data found.") {
            toast.error("No data found", { toastId: "no-data-error" });
            return;
          }
        } else {
          const blob = await res.blob();
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `WeeklyReport ${moment().format("YYYY-MM-DD h_mm_ss A")}.xlsx`
          );
          document.body.appendChild(link);
          link.click();
          window.URL.revokeObjectURL(url);
          document.body.removeChild(link);
          toast.success("File Downloaded Successfully", {
            toastId: "file-success",
          });
          return;
        }
      } else {
        toast.error("File Not Found", { toastId: "file-error" });
        return;
      }
    } catch (err) {
      handleError(err);
    }
  }

  async function getWeeklyReportView(values) {
    try {
      const obj = {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
      };
      const query = JSON.stringify(values);
      let res = await fetch(
        `${config.host}/panel/reports/weekly-report-view?query=${query}`,
        obj
      );
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function getEmployeeTimesheetDetailsAPI(body) {
    try {
      const obj = {
        method: "Post",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      };
      let res = await fetch(
        `${config.host}/panel/reports/employee-timesheet-details`,
        obj
      );
      if (res.ok) {
        const contentType = res.headers.get("Content-Type");
        if (contentType && contentType.includes("application/json")) {
          const json = await res.json();
          if (json && json?.message) {
            toast.error(json.message, { toastId: "no-data-error" });
            return;
          }
        } else {
          const blob = await res.blob();
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `Employee Timesheet Details  ${moment().format("YYYY-MM-DD h_mm_ss A")}.xlsx`
          );
          document.body.appendChild(link);
          link.click();
          window.URL.revokeObjectURL(url);
          document.body.removeChild(link);
          toast.success("File Downloaded Successfully", {
            toastId: "file-success",
          });
          return;
        }
      } else {
        toast.error("File Not Found", { toastId: "file-error" });
        return;
      }
    } catch (err) {
      handleError(err);
    }
  }

  async function getEmployeeLeaveDetailsAPI(body) {
    try {
      const obj = {
        method: "Post",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      };
      let res = await fetch(
        `${config.host}/panel/reports/employee-leave-details`,
        obj
      );
      if (res.ok) {
        const contentType = res.headers.get("Content-Type");
        if (contentType && contentType.includes("application/json")) {
          const json = await res.json();
          if (json && json?.message) {
            toast.error(json.message, { toastId: "no-data-error" });
            return;
          }
        } else {
          const blob = await res.blob();
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `Employee Leave Details  ${moment().format("YYYY-MM-DD h_mm_ss A")}.xlsx`
          );
          document.body.appendChild(link);
          link.click();
          window.URL.revokeObjectURL(url);
          document.body.removeChild(link);
          toast.success("File Downloaded Successfully", {
            toastId: "file-success",
          });
          return;
        }
      } else {
        toast.error("File Not Found", { toastId: "file-error" });
        return;
      }
    } catch (err) {
      handleError(err);
    }
  }



  /////////////////////// Non Reported hours summary report ////////////////

  async function getAllDepartmentsAPI() {
    try {
      const obj = {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
      };
      let res = await fetch(
        `${config.host}/panel/reports/all-departments`,
        obj
      );
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function getNonReportedHoursSummaryReportAPI(body) {
    try {
      const obj = {
        method: "Post",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      };
      let res = await fetch(
        `${config.host}/panel/reports/nonReported-hours-summary`,
        obj
      );
      if (res.ok) {
        const contentType = res.headers.get("Content-Type");
        if (contentType && contentType.includes("application/json")) {
          const json = await res.json();
          if (json && json?.message) {
            toast.error(json.message, { toastId: "no-data-error" });
            return;
          }
        } else {
          const blob = await res.blob();
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `Non-Complaince Report  ${moment().format("YYYY-MM-DD h_mm_ss A")}.xlsx`
          );
          document.body.appendChild(link);
          link.click();
          window.URL.revokeObjectURL(url);
          document.body.removeChild(link);
          toast.success("File Downloaded Successfully", {
            toastId: "file-success",
          });
          return;
        }
      } else {
        toast.error("File Not Found", { toastId: "file-error" });
        return;
      }
    } catch (err) {
      handleError(err);
    }
  }


  /////////////////////// Vra Monthly Schedule Report ////////////////

  async function getVraMonthlySchedule(body) {
    try {
      const obj = {
        method: "Post",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      };
      let res = await fetch(
        `${config.host}/panel/vra/report/vra-monthly-schedule`,
        obj
      );
      if (res.ok) {
        const blob = await res.blob();
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `VRA Monthly Schedule Report ${moment(body.startDate).format("DD-MM-YYYY")} to ${moment(body.endDate).format("DD-MM-YYYY")}.xlsx`
        );
        document.body.appendChild(link);
        link.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(link);
        toast.success("File Downloaded Successfully", {
          toastId: "file-success",
        });
        return;
      }
      toast.error("File Not Found", { toastId: "file-error" });
      return;
    } catch (err) {
      handleError(err);
    }
  }

  async function getVraMonthlyScheduleView(values) {
    try {
      const obj = {
        method: "Post",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(
     `${config.host}/panel/vra/report/vra-monthly-schedule-view`,
        obj
      );
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function getVraMonthlyScheduleSummaryView(values) {
    try {
      const obj = {
        method: "Post",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(
     `${config.host}/panel/vra/report/vra-monthly-schedule-forecast-summary-view`,
        obj
      );
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function getVraMonthlyScheduleSummaryExport(body) {
    try {
      const obj = {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      };
      let res = await fetch(
        `${config.host}/panel/vra/report/vra-monthly-schedule-forecast-summary`,
           obj
         );

      if (res.ok) {
        const contentType = res.headers.get("Content-Type");
        if (contentType && contentType.includes("application/json")) {
          const json = await res.json();
          if (json.message === "No data found.") {
            toast.error("No data found", { toastId: "no-data-error" });
            return;
          }
        } else {
          const blob = await res.blob();
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `RP VRA Monthly Schedule Forecast Report ${moment().format("YYYY-MM-DD h_mm_ss A")}.xlsx`
          );
          document.body.appendChild(link);
          link.click();
          window.URL.revokeObjectURL(url);
          document.body.removeChild(link);
          toast.success("File Downloaded Successfully", {
            toastId: "file-success",
          });
          return;
        }
      } else {
        toast.error("File Not Found", { toastId: "file-error" });
        return;
      }
    } catch (err) {
      handleError(err);
    }
  }


  async function getRadScheduleForecast(body) {
    try {
      const obj = {
        method: "Post",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      };
      let res = await fetch(
        `${config.host}/panel/vra/report/rad-schedule-forecast`,
        obj
      );
      if (res.ok) {
        const blob = await res.blob();
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `RP RAD Schedule Forecast ${moment(body.startDate).format("DD-MM-YYYY")} to ${moment(body.endDate).format("DD-MM-YYYY")}.xlsx`
        );
        document.body.appendChild(link);
        link.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(link);
        toast.success("File Downloaded Successfully", {
          toastId: "file-success",
        });
        return;
      }
      toast.error("File Not Found", { toastId: "file-error" });
      return;
    } catch (err) {
      handleError(err);
    }
  }


  async function getRadScheduleActual(body) {
    try {
      const obj = {
        method: "Post",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      };
      let res = await fetch(
        `${config.host}/panel/vra/report/rad-schedule-actual`,
        obj
      );
      if (res.ok) {
        const blob = await res.blob();
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `RP RAD Schedule Actual ${moment(body.startDate).format("DD-MM-YYYY")} to ${moment(body.endDate).format("DD-MM-YYYY")}.xlsx`
        );
        document.body.appendChild(link);
        link.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(link);
        toast.success("File Downloaded Successfully", {
          toastId: "file-success",
        });
        return;
      }
      toast.error("File Not Found", { toastId: "file-error" });
      return;
    } catch (err) {
      handleError(err);
    }
  }

  async function getRadScheduleForecastView(values) {
    try {
      const obj = {
        method: "Post",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(
     `${config.host}/panel/vra/report/rad-schedule-forecast-view`,
        obj
      );
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function getRadScheduleActualView(values) {
    try {
      const obj = {
        method: "Post",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(
     `${config.host}/panel/vra/report/rad-schedule-actual-view`,
        obj
      );
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function getRadScheduleForecastArchive(body) {
    try {
      const obj = {
        method: "Post",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      };
      let res = await fetch(
        `${config.host}/panel/vra/report/rad-schedule-forecast-archive`,
        obj
      );
      if (res.ok) {
        const blob = await res.blob();
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `RP RAD Schedule Forecast Archive ${moment(body.startDate).format("DD-MM-YYYY")} to ${moment(body.endDate).format("DD-MM-YYYY")}.xlsx`
        );
        document.body.appendChild(link);
        link.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(link);
        toast.success("File Downloaded Successfully", {
          toastId: "file-success",
        });
        return;
      }
      toast.error("File Not Found", { toastId: "file-error" });
      return;
    } catch (err) {
      handleError(err);
    }
  }

  async function getRadScheduleForecastArchiveView(values) {
    try {
      const obj = {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        }
      };
      const query = JSON.stringify(values);
      let res = await fetch(
     `${config.host}/panel/vra/report/rad-schedule-forecast-archive-view?query=${query}`,
        obj
      );
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function getVraRadAffinity() {
    try {
      const obj = {
        method: "Post",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(),
      };
      let res = await fetch(
        `${config.host}/panel/vra/report/vra-rad-affinity`,
        obj
      );
      if (res.ok) {
        const blob = await res.blob();
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `VRA RAD Affinity .xlsx`
        );
        document.body.appendChild(link);
        link.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(link);
        toast.success("File Downloaded Successfully", {
          toastId: "file-success",
        });
        return;
      }
      toast.error("File Not Found", { toastId: "file-error" });
      return;
    } catch (err) {
      handleError(err);
    }
  }

  async function getVraRadAffinityView(value) {
    try {
      const obj = {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        }
      };
      const query = JSON.stringify(value);
      let res = await fetch(
     `${config.host}/panel/vra/report/vra-rad-affinity-view?query=${query}`,
        obj
      );
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function getRadRosterAPI() {
    try {
      const obj = {
        method: "Post",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(),
      };
      let res = await fetch(
        `${config.host}/panel/rp/radRoster/report`,
        obj
      );
      if (res.ok) {
        const blob = await res.blob();
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `RAD Roster .xlsx`
        );
        document.body.appendChild(link);
        link.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(link);
        toast.success("File Downloaded Successfully", {
          toastId: "file-success",
        });
        return;
      }
      toast.error("File Not Found", { toastId: "file-error" });
      return;
    } catch (err) {
      handleError(err);
    }
  }

  async function RadReportViewAPI(values) {
    try {
      const obj = {
        method: "Post",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(
     `${config.host}/panel/rp/radRoster/report-view`,
        obj
      );
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }


  async function getVraRosterAPI(body) {
    try {
      const obj = {
        method: "Post",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      };
      let res = await fetch(
        `${config.host}/panel/rp/vraRoster/report`,
        obj
      );
      if (res.ok) {
        const blob = await res.blob();
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `VRA Roster.xlsx`
        );
        document.body.appendChild(link);
        link.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(link);
        toast.success("File Downloaded Successfully", {
          toastId: "file-success",
        });
        return;
      }
      toast.error("File Not Found", { toastId: "file-error" });
      return;
    } catch (err) {
      handleError(err);
    }
  }


  async function VraReportViewAPI(value) {
    console.log(value,"value")
    try {
      const obj = {
        method: "Post",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(value),
      };
      let res = await fetch(
     `${config.host}/panel/rp/vraRoster/report-view`,
        obj
      );
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function getRPAllowanceReportViewAPI(values) {
    try {
      const obj = {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        }
      };
      const query = JSON.stringify(values);
      let res = await fetch(
     `${config.host}/panel/vra/report/allowances-view?query=${query}`,
        obj
      );
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function getRPAllowanceSummaryReportViewAPI(values) {
    try {
      const obj = {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        }
      };
      const query = JSON.stringify(values);
      let res = await fetch(
     `${config.host}/panel/vra/report/allowances-summary-view?query=${query}`,
        obj
      );
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }


  async function getRadScheduleForecastCalendar(body) {
    try {
      const obj = {
        method: "Post",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      };
      let res = await fetch(
        `${config.host}/panel/vra/report/rad-schedule-forecast-calendar`,
        obj
      );
      if (res.ok) {
        const blob = await res.blob();
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `RP RAD Schedule Forecast Calendar ${moment(body.startDate).format("DD-MM-YYYY")} to ${moment(body.endDate).format("DD-MM-YYYY")}.xlsx`
        );
        document.body.appendChild(link);
        link.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(link);
        toast.success("File Downloaded Successfully", {
          toastId: "file-success",
        });
        return;
      }
      toast.error("File Not Found", { toastId: "file-error" });
      return;
    } catch (err) {
      handleError(err);
    }
  }

  async function getradScheduleForcastCalendarReportView(values) {
    try {
      const obj = {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        }
      };
      const query = JSON.stringify(values);
      let res = await fetch(
     `${config.host}/panel/vra/report/rad-schedule-forecast-calendar-view?query=${query}`,
        obj
      );
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }


  async function getVraScheduleForecastCalendar(body) {
    try {
      const obj = {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      };
      let res = await fetch(
        `${config.host}/panel/vra/report/vra-schedule-forecast-calendar`,
        obj
      );
      if (res.ok) {
        const blob = await res.blob();
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `RP VRA Schedule Forecast Calendar ${moment(body.startDate).format("DD-MM-YYYY")} to ${moment(body.endDate).format("DD-MM-YYYY")}.xlsx`
        );
        document.body.appendChild(link);
        link.click();  
        window.URL.revokeObjectURL(url);
        document.body.removeChild(link);
        toast.success("File Downloaded Successfully", {
          toastId: "file-success",
        });
        return;
      }
      toast.error("File Not Found", { toastId: "file-error" });
      return;
    } catch (err) {
      handleError(err);
    }
  }


  async function getVraScheduleForcastCalendarReportView(values) {
    try {
      const obj = {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        }
      };
      const query = JSON.stringify(values);
      let res = await fetch(
     `${config.host}/panel/vra/report/vra-schedule-forecast-calendar-view?query=${query}`,
        obj
      );
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function getEmployeeInfoReportAPI(value) {
    try {
      const obj = {
        method: "Post",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        // body: JSON.stringify(),
      };
      let res = await fetch(
        `${config.host}/panel/reports/employeeInfo-report?employmentStatus=${value}`,
        obj
      );
      if (res.ok) {
        const blob = await res.blob();
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `Employee Information Report .xlsx`
        );
        document.body.appendChild(link);
        link.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(link);
        toast.success("File Downloaded Successfully", {
          toastId: "file-success",
        });
        return;
      }
      toast.error("File Not Found", { toastId: "file-error" });
      return;
    } catch (err) {
      handleError(err);
    }
  }

  async function getEmployeeInfoReportViewAPI(values) {
    try {
      const obj = {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
         body :JSON.stringify(values)
      };
      let res = await fetch(
     `${config.host}/panel/reports/employeeInfoReport-view`,
        obj
      );
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function getVraMonthlyScheduleForecast(body) {
    try {
      const obj = {
        method: "Post",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      };
      let res = await fetch(
        `${config.host}/panel/vra/report/vra-monthly-schedule-forecast`,
        obj
      );
      if (res.ok) {
        const blob = await res.blob();
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `VRA Schedule Report ${moment(body.startDate).format("DD-MM-YYYY")} to ${moment(body.endDate).format("DD-MM-YYYY")}.xlsx`
        );
        document.body.appendChild(link);
        link.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(link);
        toast.success("File Downloaded Successfully", {
          toastId: "file-success",
        });
        return;
      }
      toast.error("File Not Found", { toastId: "file-error" });
      return;
    } catch (err) {
      handleError(err);
    }
  }

  /////////////////////// Vra Rad Pooling ////////////////

  async function getVraRadPoolingReportAPI() {
    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    try {
      const obj = {
        method: "Post",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "User-Timezone": userTimeZone
        },
        body: JSON.stringify(),
      };
      let res = await fetch(
        `${config.host}/panel/rp/vra-rad-mapping/report`,
        obj
      );
      if (res.ok) {
        const blob = await res.blob();
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `VRA RAD Pool .xlsx`
        );
        document.body.appendChild(link);
        link.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(link);
        toast.success("File Downloaded Successfully", {
          toastId: "file-success",
        });
        return;
      }
      toast.error("File Not Found", { toastId: "file-error" });
      return;
    } catch (err) {
      handleError(err);
    }
  }

  async function getVraScheduleForecastRadCalendarAPI(body) {
    try {
      const obj = {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      };
      let res = await fetch(
        `${config.host}/panel/vra/report/vra-schedule-forecast-rad-calendar`,
        obj
      );
      if (res.ok) {
        const blob = await res.blob();
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `RP VRA Schedule Forecast Rad Calendar ${moment(body.startDate).format("DD-MM-YYYY")} to ${moment(body.endDate).format("DD-MM-YYYY")}.xlsx`
        );
        document.body.appendChild(link);
        link.click();  
        window.URL.revokeObjectURL(url);
        document.body.removeChild(link);
        toast.success("File Downloaded Successfully", {
          toastId: "file-success",
        });
        return;
      }
      toast.error("File Not Found", { toastId: "file-error" });
      return;
    } catch (err) {
      handleError(err);
    }
  }

  async function getVraScheduleForcastRadCalendarReportView(values) {
    try {
      const obj = {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        }
      };
      const query = JSON.stringify(values);
      let res = await fetch(
     `${config.host}/panel/vra/report/vra-schedule-forecast-rad-calendar-view?query=${query}`,
        obj
      );
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

   /////////////////////// Employee Informations ////////////////

  async function getEmployeeManagerInfoReportAPI(value) {
    try {
      const obj = {
        method: "Post",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        // body: JSON.stringify(),
      };
      //  const query = JSON.stringify(value);
      let res = await fetch(
        `${config.host}/panel/reports/employee-manager-information?employmentStatus=${value}`,
        obj
      );
      if (res.ok) {
        const blob = await res.blob();
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `Employee Manager Information Report .xlsx`
        );
        document.body.appendChild(link);
        link.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(link);
        toast.success("File Downloaded Successfully", {
          toastId: "file-success",
        });
        return;
      }
      toast.error("File Not Found", { toastId: "file-error" });
      return;
    } catch (err) {
      handleError(err);
    }
  }

  async function getEmployeeLeavesSummaryAPI(body) {
    try {
      const obj = {
        method: "Post",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      };
      let res = await fetch(
        `${config.host}/panel/reports/employee-leaves-summary`,
        obj
      );
      if (res.ok) {
        const contentType = res.headers.get("Content-Type");
        if (contentType && contentType.includes("application/json")) {
          const json = await res.json();
          if (json && json?.message) {
            toast.error(json.message, { toastId: "no-data-error" });
            return;
          }
        } else {
          const blob = await res.blob();
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `Employee Leaves Summary  ${moment().format("YYYY-MM-DD h_mm_ss A")}.xlsx`
          );
          document.body.appendChild(link);
          link.click();
          window.URL.revokeObjectURL(url);
          document.body.removeChild(link);
          toast.success("File Downloaded Successfully", {
            toastId: "file-success",
          });
          return;
        }
      } else {
        toast.error("File Not Found", { toastId: "file-error" });
        return;
      }
    } catch (err) {
      handleError(err);
    }
  }

  /////////////////////// Employee Attendance ////////////////

  
  async function getAttendanceDetailsReportAPI(body) {
    try {
      const obj = {
        method: "Post",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      };
      let res = await fetch(
        `${config.host}/panel/reports/employee-attendance-details`,
        obj
      );
      if (res.ok) {
        const contentType = res.headers.get("Content-Type");
        if (contentType && contentType.includes("application/json")) {
          const json = await res.json();
          if (json && json?.message) {
            toast.error(json.message, { toastId: "no-data-error" });
            return;
          }
        } else {
          const blob = await res.blob();
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
         const start = moment(body.startDate).format("YYYY-MM-DD");
const end = moment(body.endDate).format("YYYY-MM-DD");

link.setAttribute(
  "download",
  `Employee Attendance Details (${start} to ${end}).xlsx`
);
          document.body.appendChild(link);
          link.click();
          window.URL.revokeObjectURL(url);
          document.body.removeChild(link);
          toast.success("File Downloaded Successfully", {
            toastId: "file-success",
          });
          return;
        }
      } else {
        toast.error("File Not Found", { toastId: "file-error" });
        return;
      }
    } catch (err) {
      handleError(err);
    }
  }

  
  async function getRPAttendanceDetailsReportAPI(body) {
    try {
      const obj = {
        method: "Post",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      };
      let res = await fetch(
        `${config.host}/panel/reports/rp_employee-attendance-details`,
        obj
      );
      if (res.ok) {
        const contentType = res.headers.get("Content-Type");
        if (contentType && contentType.includes("application/json")) {
          const json = await res.json();
          if (json && json?.message) {
            toast.error(json.message, { toastId: "no-data-error" });
            return;
          }
        } else {
          const blob = await res.blob();
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
         const start = moment(body.startDate).format("YYYY-MM-DD");
const end = moment(body.endDate).format("YYYY-MM-DD");

link.setAttribute(
  "download",
  `RP Employees Attendance Details (${start} to ${end}).xlsx`
);
          document.body.appendChild(link);
          link.click();
          window.URL.revokeObjectURL(url);
          document.body.removeChild(link);
          toast.success("File Downloaded Successfully", {
            toastId: "file-success",
          });
          return;
        }
      } else {
        toast.error("File Not Found", { toastId: "file-error" });
        return;
      }
    } catch (err) {
      handleError(err);
    }
  }


  /////////////////// Employee Resignation ///////////////////////

    async function getEmployeeResignationDetailsAPI(body) {
    try {
      const obj = {
        method: "Post",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      };
      let res = await fetch(
        `${config.host}/panel/reports/employee-resignation-details`,
        obj
      );
      if (res.ok) {
        const contentType = res.headers.get("Content-Type");
        if (contentType && contentType.includes("application/json")) {
          const json = await res.json();
          if (json && json?.message) {
            toast.error(json.message, { toastId: "no-data-error" });
            return;
          }
        } else {
          const blob = await res.blob();
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `Employee Resignation Details  ${moment().format("YYYY-MM-DD h_mm_ss A")}.xlsx`
          );
          document.body.appendChild(link);
          link.click();
          window.URL.revokeObjectURL(url);
          document.body.removeChild(link);
          toast.success("File Downloaded Successfully", {
            toastId: "file-success",
          });
          return;
        }
      } else {
        toast.error("File Not Found", { toastId: "file-error" });
        return;
      }
    } catch (err) {
      handleError(err);
    }
  }

   async function getPoolPrepReportAPI(body) {
    try {
      const obj = {
        method: "Post",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      };
      let res = await fetch(
        `${config.host}/panel/rp/poolPrepRoster/report`,
        obj
      );
      if (res.ok) {
        const blob = await res.blob();
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `Pool Prep Roster.xlsx`
        );
        document.body.appendChild(link);
        link.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(link);
        toast.success("File Downloaded Successfully", {
          toastId: "file-success",
        });
        return;
      }
      toast.error("File Not Found", { toastId: "file-error" });
      return;
    } catch (err) {
      handleError(err);
    }
  }

   async function getAtcRosterReportAPI(body) {
    try {
      const obj = {
        method: "Post",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      };
      let res = await fetch(
        `${config.host}/panel/rp/atcRoster/report`,
        obj
      );
      if (res.ok) {
        const blob = await res.blob();
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `ATC Roster.xlsx`
        );
        document.body.appendChild(link);
        link.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(link);
        toast.success("File Downloaded Successfully", {
          toastId: "file-success",
        });
        return;
      }
      toast.error("File Not Found", { toastId: "file-error" });
      return;
    } catch (err) {
      handleError(err);
    }
  }

    async function getExperienceSubmissionReportAPI(value) {
    try {
      const obj = {
        method: "Post",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(),
      };
      let res = await fetch(
        `${config.host}/panel/reports/experience-submission-report?employmentStatus=${value}`,
        obj
      );
      if (res.ok) {
        const blob = await res.blob();
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
       const now = new Date();

        const date = now.toLocaleDateString("en-GB").replace(/\//g, "-"); 

let hours = now.getHours();
const minutes = now.getMinutes().toString().padStart(2, "0");
const ampm = hours >= 12 ? "PM" : "AM";

hours = hours % 12;
hours = hours ? hours : 12; 
hours = hours.toString().padStart(2, "0");

const time = `${hours}-${minutes}_${ampm}`;

link.setAttribute(
  "download",
  `ExperienceSubmissionReport_${date}_${time}.xlsx`
);
        document.body.appendChild(link);
        link.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(link);
        toast.success("File Downloaded Successfully", {
          toastId: "file-success",
        });
        return;
      }
      toast.error("File Not Found", { toastId: "file-error" });
      return;
    } catch (err) {
      handleError(err);
    }
  }

    async function getAllEmployeesAPI() {
    try {
      const obj = {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
      };
      let res = await fetch(
        `${config.host}/panel/reports/all-employees`,
        obj
      );
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

    async function getEmployeeDocumentsAPI(body) {
    try {
      const obj = {
        method: "Post",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      };
      let res = await fetch(
        `${config.host}/background-jobs/employee-documents`,
        obj
      );
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function getBackgroundLogsAPI(values) {
      try {
        const obj = {
          method: "GET",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
        };
        const query = JSON.stringify(values);
        const res = await fetch(
          `${config.host}/panel/reports/employee-document-logs?query=${query}`,
          obj
        );
        return handleResponse(res);
      } catch (err) {
        handleError(err);
      }
    }

  return {
    getAllManagerProjects,
    getAllManagerEmployees,
    getTimesheetSummaryReportAPI,
    getTimesheetSummaryReportViewAPI,
    getAllProjectNames,
    getAllProjectTasks,
    getWeeklyReportAPI,
    getWeeklyReportView,
    
    getAllDepartmentsAPI,
    getNonReportedHoursSummaryReportAPI,
    getEmployeeTimesheetDetailsAPI,
    getEmployeeLeaveDetailsAPI,
    getVraMonthlySchedule,
    getVraMonthlyScheduleView,
    getVraMonthlyScheduleSummaryView,
    getVraMonthlyScheduleSummaryExport,
    getVraMonthlyScheduleForecast,

    getRadScheduleForecast,
    getRadScheduleActual,
    getRadScheduleForecastView,
    getRadScheduleActualView,
    getRadRosterAPI,
    RadReportViewAPI,
    getVraRosterAPI,
    VraReportViewAPI,
    getRadScheduleForecastArchive,
    getRadScheduleForecastArchiveView,
    getVraRadAffinity,
    getVraRadAffinityView,

    getRPAllowanceReportViewAPI,
    getRPAllowanceSummaryReportViewAPI,
    getradScheduleForcastCalendarReportView,
    getRadScheduleForecastCalendar,
    getVraScheduleForecastCalendar,
    getVraScheduleForcastCalendarReportView,
    getVraScheduleForecastRadCalendarAPI,
    getVraScheduleForcastRadCalendarReportView,
    getEmployeeInfoReportAPI,
    getEmployeeInfoReportViewAPI,

    getVraRadPoolingReportAPI,

    getEmployeeManagerInfoReportAPI,
    getEmployeeLeavesSummaryAPI,

    getAttendanceDetailsReportAPI,
    getRPAttendanceDetailsReportAPI,
    getEmployeeResignationDetailsAPI,

    getPoolPrepReportAPI,
    getAtcRosterReportAPI,

    getExperienceSubmissionReportAPI,
   
    getAllEmployeesAPI,
    getEmployeeDocumentsAPI,
    getBackgroundLogsAPI
  };
};

export default reportsAPI;
